import Cropper from './cropper.js'

let cropperInstance
function getCropperInstance() {
  cropperInstance = cropperInstance || Cropper.newInstance()
  return cropperInstance
}
function cropper(options) {
  const instance = getCropperInstance()
  instance.show(options)
}
export default {
  show(options) {
    return cropper(options)
  },
  destory() {
    const instance = getCropperInstance()
    instance.destory()
  }
}
